import styled from "@emotion/styled";
import { TextField } from '@fluentui/react';

export const FormTextField = styled(TextField)<{
  hasError?: boolean;
  background?: string;
}>`
  &.is-active {
    .ms-TextField-fieldGroup {
      border-color: ${p =>
        p.hasError ? p.theme.palette.red : p.theme.palette.themePrimary};
    }
  }
  &.is-active.hasError {
    .ms-TextField-fieldGroup {
      border-color: ${p => p.theme.palette.red};
    }
  }
  .ms-TextField-fieldGroup {
    border-bottom: 1px solid ${p => p.theme.palette.neutralTertiaryAlt};
    border-radius: 0;
    background-color: ${p => p.background ?? undefined};
  }
  &&& .ms-TextField-suffix {
    border: 0;
  }
  &.is-disabled {
    input {
      background: ${p => p.background ?? p.theme.palette.white};
    }
  }
  &.noMargin {
    margin-bottom: 0;
  }
  textarea[disabled] {
    background: ${p => p.background ?? p.theme.palette.white};
  }
`;
